import {
    AdTargeting,
    shouldDisplayCricketWidget,
    Topic,
} from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { metrics } from '@news-mono/component-library'

import { BaseClientConfig } from '@news-mono/web-common'
import { PageType, GetRouteAdTargeting } from '@news-mono/web-common'
import { topicParallax } from './topic-parallax'
import { billboardLeaderboardMrec } from '../ad-units'
import { TheWestSection } from '@news-mono/component-library'
import { getTopicSponsor } from './get-topic-sponsor'

export interface Props {
    topic: Topic
    publicationKind?: 'article' | 'gallery'
    topicSource?: string
    config: BaseClientConfig
    section: TheWestSection
    getAdTargeting: GetRouteAdTargeting
}

export const horizontalCricketWidgetLayout = layout.component({
    type: 'HorizontalCricketWidget',
    props: {},
})

export const getTopicPageRouteInfo = ({
    topic,
    publicationKind,
    topicSource,
    section,
    getAdTargeting,
}: Props): PageType<TheWestSection> => {
    const { adUnitPath, ssAdUnits, topics } = getAdTargeting(
        'home',
        section,
        topic,
    )

    const adTargeting: AdTargeting = {
        pageId: topic.title,
        adUnitPath,
        ssAdUnits,
        topics,
    }

    const sponsor = getTopicSponsor(topic)
    const isSponsoredCollection = !!sponsor

    const shouldDisplayBreakingNews = () => section === 'default'

    return {
        kind: 'page',
        heading: topic.title,
        hideHeading: true,
        pageType: 'topic',
        includeFromSectionInMetaDescription: !topic.seoDescription,
        pageMeta: {
            description:
                topic.seoDescription || `The Latest in ${topic.seoTitle}`,
            title: topic.seoTitle || topic.title,
        },
        adTargeting,
        section,
        compositions: [
            layout.composition({
                type: 'box',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    horizontalGutters: 'outerMargin',
                    verticalGutters: ['outerMargin', 'unset'],
                },
                contentAreas: {
                    main: [
                        ...(shouldDisplayBreakingNews()
                            ? [
                                  layout.component({
                                      type: 'breaking-news',
                                      props: {
                                          dataDefinitionArgs: {
                                              type: 'curation',
                                              name: 'breaking-news',
                                              offset: 0,
                                              pageSize: 1,
                                          },
                                      },
                                  }),
                              ]
                            : []),
                        layout.component({
                            type: 'breadcrumb',
                            props: {
                                topic,
                                sponsor,
                                enableHeaderTag: true,
                            },
                        }),
                        ...(shouldDisplayCricketWidget(topic)
                            ? [horizontalCricketWidgetLayout]
                            : []),
                    ],
                },
            }),
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    horizontalGutters: true,
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'lima',
                            props: {
                                verticalSpacing: 'xl',
                                fontScale: 1.2,
                                fixedRatios: ['16:9'],
                                initialColumns: 1,
                                intermediateColumns: 2,
                                finalColumns: 4,
                                hasBackground: true,
                                isSponsoredCollection,

                                dataDefinitionArgs: {
                                    type: 'listing',
                                    topics: [topic.id],
                                    includeSubTopics: true,
                                    publicationKind,
                                    source: topicSource,
                                    paging: {
                                        page: 1,
                                        pageSize: 8,
                                    },
                                },
                            },
                        }),
                        ...topicParallax(),
                        layout.component({
                            type: 'lima',
                            props: {
                                verticalSpacing: 'xl',
                                fontScale: 1.2,
                                fixedRatios: ['16:9'],
                                hasBackground: true,
                                isSponsoredCollection,
                                initialColumns: 1,
                                intermediateColumns: 2,
                                finalColumns: 4,

                                dataDefinitionArgs: {
                                    type: 'listing',
                                    topics: [topic.id],
                                    includeSubTopics: true,
                                    publicationKind,
                                    source: topicSource,
                                    paging: {
                                        page: 1,
                                        pageOffset: 8,
                                        pageSize: 8,
                                    },
                                },
                            },
                        }),
                        ...billboardLeaderboardMrec('one'),
                        layout.component({
                            type: 'lima',
                            props: {
                                verticalSpacing: 'md',
                                fontScale: 1.2,
                                fixedRatios: ['16:9'],
                                hasBackground: true,
                                isSponsoredCollection,
                                initialColumns: 1,
                                intermediateColumns: 2,
                                finalColumns: 4,

                                loadMoreEnabled: true,
                                dataDefinitionArgs: {
                                    type: 'listing',
                                    topics: [topic.id],
                                    includeSubTopics: true,
                                    publicationKind,
                                    source: topicSource,
                                    paging: {
                                        page: 1,
                                        pageOffset: 16,
                                        pageSize: 8,
                                    },
                                },
                            },
                        }),
                        ...billboardLeaderboardMrec('two'),
                    ],
                },
            }),
        ],
    }
}
